import { Component, OnInit, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Au10tixService } from '../../services/au10tix.service';
import { FlutterBridgeService } from '../../services/flutter-bridge.service';
import { TokenService } from '../../services/token.service';

@Component({
  selector: 'app-authorize',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './authorize.component.html',
  styleUrl: './authorize.component.scss'
})
export class AuthorizeComponent implements OnInit {
  private readonly au10tixService = inject(Au10tixService);
  private readonly flutterBridge = inject(FlutterBridgeService);
  private readonly tokenService = inject(TokenService);

  readonly isLoading = signal<boolean>(false);
  readonly error = signal<string | null>(null);
  readonly securemeLink = signal<string | null>(null);


  ngOnInit(): void {
    this.loadAuthorizeUrl();
  }

  private async loadAuthorizeUrl(): Promise<void> {
    this.isLoading.set(true);
    this.error.set(null);

    const tokenAvailable = await this.tokenService.waitForToken();

    if (!tokenAvailable) {
      this.error.set('Token is not available. Please ensure Flutter has initialized the token.');
      this.isLoading.set(false);
      return;
    }

    this.au10tixService.getAuthorizeUrl().subscribe({
      next: (data) => {
        this.securemeLink.set(data.response.securemeLink);
        this.isLoading.set(false);

        if (data.response.securemeLink) {
          window.location.href = data.response.securemeLink;
        }
      },
      error: (err) => {
        this.error.set(err.message ?? 'Failed to load authorization URL');
        this.isLoading.set(false);
        console.error('Error loading authorize URL:', err);
      }
    });
  }

    protected testCallback() {
        const sessionId = '1234567890';
        this.flutterBridge.sendDataToFlutter({sessionId: sessionId});
    }

    protected testCallback1() {
        window.Auth10tixBridge = {
            getJwtToken: () => {
                return 'TEST TOKEN'
            }
        };
        window.location.href = 'https://self-onboard-uat.lpay.liquidgroup.sg/test';
    }
}

